/* eslint no-shadow: ["error", { "allow": ["state"] }] */
import Vue from 'vue';
import Vuex from 'vuex';

import stream from '../stream';

import user from './modules/user';
import teamInformation from './modules/teamInformation';
import timeline from './modules/timeline';
import timeShift from './modules/timeShift';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    user,
    teamInformation,
    timeline,
    timeShift,
    stream: stream.store,
  },
});
